import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import ProjectHelp from "components/UnifiedProject/Help/ProjectHelp";
import * as globalReducer from "containers/App/reducer";

class ProjectHelpContainer extends React.PureComponent {
  render() {
    const {} = this.props;

    return <ProjectHelp {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateIsHelpOpen: () => dispatch(globalReducer.updateIsShowProjectHelp())
});

const mapStateToProps = (state, ownProps) => {
  return {
    isHelpOpen: globalReducer.getIsShowProjectHelp(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ProjectHelpContainer);
